import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import DesignElement from 'components/SeriesDetail/Template/DesignElement';
import expandImg from './mini@2x.svg';
import Tooltip from '../../Tooltip';
import DesignOptionsDescription from '../DesignOptionsDescription';

export const DesignOptions = ({
  designPackage,
  onClickOrTouch,
  selectedDesignOption,
  isDuplicate,
  templateId,
  mini,
  primaryOptions,
  designOptions,
  expand,
  expandMiniMore,
  secondaryOptions,
}) => {
  return (
    <div className={styles.container}>
      <Tooltip
        className={styles.tooltip}
        tooltipText={
          <DesignOptionsDescription
            mini={mini}
            designPackage={designPackage}
            primaryOptions={primaryOptions}
            secondaryOptions={secondaryOptions}
          />
        }
      />
      <div className={styles.designOptionsContainer}>
        {mini ? (
          <div className={styles.designOptions}>
            {primaryOptions.map(
              optionKey =>
                designPackage[optionKey] && (
                  <DesignElement
                    key={`${templateId}${designPackage[optionKey].id}`}
                    url={designPackage[optionKey].iconImgUrl}
                    alt={designPackage[optionKey].id}
                    onClickOrTouch={onClickOrTouch}
                    optionKey={optionKey}
                    selectedDesignOption={selectedDesignOption}
                    isDuplicate={isDuplicate}
                  />
                ),
            )}
            <span className={styles.optionWrapper}>
              <img
                onClick={expandMiniMore}
                src={expandImg}
                alt={'Expand Designs'}
                className={styles.expand}
              />
              <span
                className={
                  selectedDesignOption === 'more'
                    ? styles.withTriangle
                    : styles.noTriangle
                }
              />
            </span>
          </div>
        ) : (
          designOptions.map(
            optionKey =>
              designPackage[optionKey] && (
                <DesignElement
                  key={`${templateId}${designPackage[optionKey].id}`}
                  url={designPackage[optionKey].iconImgUrl}
                  alt={designPackage[optionKey].id}
                  onClickOrTouch={onClickOrTouch}
                  optionKey={optionKey}
                  selectedDesignOption={selectedDesignOption}
                  isDuplicate={isDuplicate}
                />
              ),
          )
        )}
      </div>
    </div>
  );
};

export default enhance(DesignOptions);
